import { getBoxValue } from './Const/functions';

const Style = ({ attributes, clientId }) => {

	const { titleTypo, titleColor, descTypo, descColor, titleMargin, descMargin, arrow, indicator, SliderOverly } = attributes;
	return <style dangerouslySetInnerHTML={{
		__html: `
		#bsbMainArea-${clientId} h5{
			font-size: ${titleTypo?.fontSize}px;
			color: ${titleColor};
			font-weight: ${titleTypo?.fontWeight};
			margin: ${getBoxValue(titleMargin)};
		}
		#bsbMainArea-${clientId} p {
			font-size: ${descTypo?.fontSize}px;
			color: ${descColor};
			font-weight: ${descTypo?.fontWeight};
			margin: ${getBoxValue(descMargin)};
			line-height:${descTypo?.lineHeight};
		} 
		#bsbMainArea-${clientId} .carousel-item {
			height: 400px;
			object-fit: cover;
		}
		#bsbMainArea-${clientId} svg{
			fill:${arrow.color};
		}
		#bsbMainArea-${clientId} .carousel-item{
			position:relative;
		}
		#bsbMainArea-${clientId} .carousel-item:after{
			content: '';
			width: 100%;
			height: 100%;
			top: 0;
			position: absolute;
			left: 0;
			background: ${SliderOverly};
		}
		#bsbMainArea-${clientId} .carousel-indicators button.customDesign {
			border-radius: 50%;
			width: ${indicator.size}px !important;
			height: ${indicator.size}px !important;
		}
		#bsbMainArea-${clientId} .carousel-caption.d-none.d-md-block{
			z-index:1!important;
		}
		#bsbMainArea-${clientId} .carousel-indicators button{
			background-color:${indicator.color}
		}
		#bsbMainArea-${clientId} .carousel-indicators button.active{
			background-color:${indicator.activeColor};
		}
		#bsbMainArea-${clientId} .bsbButtonDesign button{
			background:none;
		}
		#bsbMainArea-${clientId} .bsbButtonDesign button:hover {
			background:none;	 
		}

`.replace(/\s+/g, ' ')
	}} />
}
export default Style;